import { GlobalOutlined } from "@ant-design/icons";
import { useIntl, defineMessages } from "react-intl";

import { locales, useCurrentLocale } from "../../../lib/hooks/basic/locales";
import type { AvailableLocales } from "../../../lib/locale/config";
import { Dropdown } from "../../shared/Dropdown";

const messages = defineMessages({
  selectLocality: {
    id: "localities.select",
    defaultMessage: "Select Locality",
  },
  localeSwitched: {
    id: "locale.switch",
    defaultMessage: "switch",
  },
});

export function LanguageMenu() {
  const intl = useIntl();

  const { currentLocale, setLocale, showSuccess } = useCurrentLocale();

  return (
    <Dropdown
      menu={{
        triggerSubMenuAction: "click",
        selectedKeys: [currentLocale],
        items: Object.entries(locales).map(([code, locale]) => ({
          key: code,
          onClick: () => {
            setLocale(code as AvailableLocales);
            showSuccess(
              intl.formatMessage(messages.localeSwitched, {
                language: locale.name,
              })
            );
          },
          icon: <span className="anticon">{locale.emoji}</span>,
          label: locale.name,
        })),
      }}
      placement="bottomLeft"
      className="menu-item hover"
    >
      <span data-language={true} style={{ display: "inline-flex" }}>
        <GlobalOutlined style={{ fontSize: 20 }} />
      </span>
    </Dropdown>
  );
}
